import * as React from 'react';
import PropTypes from 'prop-types';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import AppBar from './components/AppBar';
import Hero from './components/Hero';
import LogoCollection from './components/LogoCollection';
import Highlights from './components/Highlights';
import Pricing from './components/Pricing';
import Features from './components/Features';
//import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import getLPTheme from './getLPTheme';
import ZapingWidgetClient from '../components/ZapingWidgetClient';
import WhatsAppWidget from './components/WhatsAppWidget';

import '../i18n';

//const defaultTheme = createTheme({});
const defaultTheme = createTheme({
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

function ToggleCustomTheme({ showCustomTheme, toggleCustomTheme }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100dvw',
        position: 'fixed',
        bottom: 24,
      }}
    >
      
    </Box>
  );
}

ToggleCustomTheme.propTypes = {
  showCustomTheme: PropTypes.bool.isRequired, // Change from object to bool
  toggleCustomTheme: PropTypes.func.isRequired,
};

export default function LandingPage() {
  const [mode, setMode] = React.useState('dark');
  const [showCustomTheme, setShowCustomTheme] = React.useState(true);
  const LPtheme = createTheme(getLPTheme(mode));

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'dark' : 'dark'));
  };

  const toggleCustomTheme = () => {
    setShowCustomTheme((prev) => !prev);
  };

  return (
    <ThemeProvider theme={LPtheme}>
      <CssBaseline />
      <AppBar mode={mode} toggleColorMode={toggleColorMode} />
      <Box sx={{ bgcolor: 'background.default' }}>
         {/*<LogoCollection />*/}
        
        <Features />
        <Divider />
        <Highlights />
        <Divider />

        {/*<Testimonials />
        <Divider />*/}

        <Pricing />
        <Divider />
        <FAQ />
        <Footer />
      </Box>
      
      {/* Positioning ZapingWidgetClient */}
      <Box
        sx={{
          position: 'fixed',
          bottom: '10%', // 10% from the bottom
          right: 0,       // 0% from the right
          // Uncomment the next line ONLY if you decide to anchor from the top instead
          // top: '20%', 
          zIndex: 1300010, // Ensures it's above most other elements (adjust as needed)
          // Optional: Adjust width or other styles as necessary
        }}
      >
        <ZapingWidgetClient />
      </Box>

      <WhatsAppWidget />
      <ToggleCustomTheme
        showCustomTheme={showCustomTheme}
        toggleCustomTheme={toggleCustomTheme}
      />
    </ThemeProvider>
  );
}
